import { useContext } from 'react';

import { RemotesContext } from '~/modules/remotes/contexts/RemotesContext.ts';

// This is tested via `../components/RemotesProvider.test.tsx`, so no unit tests
// are needed for this hook specifically.
export function useRemotes() {
  return useContext(RemotesContext);
}
